import React from 'react';
const footerLinks = [{
  label: 'Home',
  href: '#home'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Services',
  href: '#services'
}, {
  label: 'Noir Atelier',
  href: '#noir-atelier'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Footer() {
  return <footer className="w-full bg-dark-900 border-t border-white/5" data-id="element-46">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16" data-id="element-47">
        <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-48">
          <div data-id="element-49">
            <span className="text-gold font-display text-xl font-bold tracking-widest block mb-4" data-id="element-50">
              VANSCAPE
            </span>
            <p className="text-white/40 text-sm leading-relaxed font-body max-w-xs" data-id="element-51">
              Proudly at the forefront of PV5 campervan excellence. Based in
              Buckinghamshire, operating from Europe's largest Kia showroom.
            </p>
          </div>

          <div data-id="element-52">
            <h4 className="text-white/80 text-sm font-semibold tracking-widest uppercase mb-4 font-body" data-id="element-53">
              Navigation
            </h4>
            <nav className="flex flex-col gap-3" data-id="element-54">
              {footerLinks.map(link => <a key={link.label} href={link.href} className="text-white/40 text-sm hover:text-gold transition-colors duration-300 font-body" data-id="element-55">
                  {link.label}
                </a>)}
            </nav>
          </div>

          <div data-id="element-56">
            <h4 className="text-white/80 text-sm font-semibold tracking-widest uppercase mb-4 font-body" data-id="element-57">
              Get in Touch
            </h4>
            <div className="space-y-3 text-white/40 text-sm font-body" data-id="element-58">
              <p data-id="element-59">Vanscape Ltd</p>
              <p data-id="element-60">Buckinghamshire, United Kingdom</p>
              <a href="mailto:info@kiacampervans.co.uk" className="block hover:text-gold transition-colors duration-300" data-id="element-61">
                info@kiacampervans.co.uk
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-62">
          <p className="text-white/25 text-xs font-body" data-id="element-63">
            © {new Date().getFullYear()} Vanscape Ltd. All rights reserved.
          </p>
          <p className="text-white/25 text-xs font-body italic" data-id="element-64">
            Vanscape | Buckinghamshire — Proudly at the forefront of PV5
            campervan excellence.
          </p>
        </div>
      </div>
    </footer>;
}